<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Purchase Invoices Edit</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <div>
          <v-row dense>
            <v-col cols="12" xs="12" md="3">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    single-line
                    v-model="record.StartDate"
                    label="From"
                    prepend-icon="mdi-calendar-month"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

    
            <v-col cols="12" xs="12" md="3">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    single-line
                    v-model="record.EndDate"
                    label="To"
                    prepend-icon="mdi-calendar-month"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                autocomplete="off"
                dense
                outlined
                v-model="record.SupplierId"
                :items="suppliers"
                label="Supplier"
                item-text="Name"
                item-value="id"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-btn
                class="right"
                color="primary"
                :loading="loader"
                @click="getReport"
              >Query Data</v-btn>
            </v-col>
          </v-row> 

          <v-row dense>
            <v-col cols="12">
              <v-text-field dense label="Search" v-model="search"></v-text-field>
            </v-col>

            <v-divider></v-divider>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-data-table
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="dailyReport"
              :search="search"
            >
              <!-- template -->
              <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal | currency }}</template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.TotalPaid="{ item }">
                {{
                item.TotalPaid | currency
                }}
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.Balance="{ item }">
                {{
                item.Balance | currency
                }}
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.Date="{ item }">
                {{
                item.Date | date
                }}
              </template>
              <!-- end -->
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="accent" text :to="`/edit-purchase/${item.id}`">
                  <v-icon left>mdi-pencil</v-icon> Edit Purchase
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
              <!-- snackbar -->
              <snackbar ref="snackbar"></snackbar>
            </v-col>
          </v-row>

        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import "export-json-excel";
export default {
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    role() {
      return localStorage.getItem("userRole");
    }
  },
  data() {
    return {
      record: {},
      productsDialog: false,
      salesLoader: false,
      soldItems: [],
      pageItems: 100,
      zeroValue: 0,
      menu1: false,
      menu2: false,
      loader: false,
      search: null,
      suppliers: [],
      reportData: {},
      TotalReturns: null,
      TotalServices: 0,
      returnsData: [],
      reportDataAllSales: [],
      cancelledDialog: false,
      cancelledData: [],
      dailyReport:  [],
      drivers: [],
      dailySales: [],
      totalPurchases: 0,
      totalPayments: 0,
      creditSales: 0,
      headers: [
        { text: "Doc Num.", value: "DocNum" },
        { text: "Supplier", value: "SupplierName" },
        { text: "Total", value: "DocTotal" },
        { text: "Paid", value: "TotalPaid" },
        { text: "Balance", value: "Balance" },
        { text: "Date", value: "Date" },
        { text: "Action", value: "action" },
      ],
    };
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getReport() {
      let data = this.record;
      const self = this;
      const url = `/daily-purchases-report`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.dailyReport = res.ResponseData.purchases;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    exportToExcel() {}
  },
  created() {
    this.getSuppliers();
  }
};
</script>

<style lang="scss" scoped>
</style>